// extracted by mini-css-extract-plugin
export var modalHeader = "index-module--modalHeader--cbb32";
export var modalHeaderTitle = "index-module--modalHeaderTitle--a5b6a";